export default function KaretUpIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 9.5L8.37963 6.4429C8.18008 6.21009 7.81992 6.21009 7.62037 6.4429L5 9.5"
        fill="#674759"
      />
      <path
        d="M11 9.5L8.37963 6.4429C8.18008 6.21009 7.81992 6.21009 7.62037 6.4429L5 9.5H11Z"
        stroke="#674759"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
